import { all, fork, put, takeEvery } from 'redux-saga/effects';
import { stardardRequest } from '../../utils';
import { API_BASE } from '../../constants/api.constant'

import {
  APPRAISAL_SUBMIT,
  HOTKEY_SUBMIT,
  LEADS_FETCH_BY_ID,
  IMAGE_REQUEST,
  IMAGE_REQUIRED_SMS_SUBMIT,
} from '../actions';

export function* watchLeadsFetchIdRequest() {
  const action = LEADS_FETCH_BY_ID
  yield takeEvery(action.REQUEST, stardardRequest({
    action: action,
    requestOptionsFromPayload: (payload) => {
      return {
        method: 'get',
        url: `${API_BASE}/v1/public/${payload.id}`
      }
    },
    dataPath: 'result',
    dataDefault: null,
  }));
}

export function* watchAppraisalSubmitRequest() {
  const action = APPRAISAL_SUBMIT
  yield takeEvery(action.REQUEST, stardardRequest({
    action: action,
    requestOptionsFromPayload: (payload) => {
      const { id, ...data } = payload
      return {
        method: 'post',
        url: `${API_BASE}/v1/public/${payload.id}/save`,
        data
      }
    },
    dataPath: 'result',
    dataDefault: null,
  }));
}

export function* watchHotkeySubmitRequest() {
  const action = HOTKEY_SUBMIT
  yield takeEvery(action.REQUEST, stardardRequest({
    action: action,
    requestOptionsFromPayload: (payload) => {
      return {
        method: 'post',
        url: `${API_BASE}/v1/public/${payload.id}/hotkey`,
        data: {}
      }
    },
    dataPath: 'result',
    dataDefault: null,
  }));
}

export function* watchImageRequest() {
  const action = IMAGE_REQUEST
  yield takeEvery(action.REQUEST, stardardRequest({
    action: action,
    requestOptionsFromPayload: (payload) => {
      return {
        method: 'get',
        url: `${API_BASE}/v1/public/${payload.id}/images`,
        data: {}
      }
    },
    dataPath: 'images',
    dataDefault: [],
  }));
}

export function* watchImageRequiredSmsSubmitRequest() {
  const action = IMAGE_REQUIRED_SMS_SUBMIT
  yield takeEvery(action.REQUEST, stardardRequest({
    action: action,
    requestOptionsFromPayload: (payload) => {
      return {
        method: 'post',
        url: `${API_BASE}/v1/public/${payload.id}/images-required-sms`,
        data: {}
      }
    },
    dataPath: 'result',
    dataDefault: null,
  }));
}

export default function* rootSaga() {
  yield all([
    fork(watchLeadsFetchIdRequest),
    fork(watchAppraisalSubmitRequest),
    fork(watchHotkeySubmitRequest),
    fork(watchImageRequest),
    fork(watchImageRequiredSmsSubmitRequest),
  ]);
}